import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import Skeleton from 'react-skeleton-loader';

const renderDownloadDocuments = (isLoading, filteredDocuments, handleDownload) => {
  if (isLoading) {
    let i = 3;
    const skeletonArray = [];
    while (i > 0) {
      i -= 1;
      const element = (
        <tr className="row" key={`skeleton-${i}`}>
          <td className="col col-sm-11 col-xs-8"><Skeleton height="38px" widthRandomness="0" color="#ededed" /></td>
          <td className="col col-sm-1 col-xs-4"><Skeleton height="24px" widthRandomness="0.5" color="#ededed" /></td>
        </tr>
      );
      skeletonArray.push(element);
    }
    return skeletonArray;
  }
  return filteredDocuments.map(docs => (
    <tr className="row body-md">
      <td className="col col-sm-10 col-xs-8">{docs.title}</td>
      <td className="col col-sm-2 col-xs-4 col">
        <button
          type="button"
          className="btn btn-link p-0 ml-auto"
          onClick={(e) => {
            e.preventDefault();
            handleDownload(docs.id);
          }}
        >
          <FormattedMessage id="DOWNLOAD" className="mt-2" />
        </button>
      </td>
    </tr>
  ));
};

const filterDocuments = documents => documents.filter(docs => docs.type === 'NoSignature' || docs.type === null);

const DownloadDocumentsList = ({
  documents,
  title,
  isLoading,
  handleDownload,
}) => {
  const filteredDocuments = filterDocuments(documents);
  if (filteredDocuments.length > 0) {
    return (
      <Table className="table-hover mt-4">
        <thead>
          <tr className="small d-flex font-weight-bold body-md">
            <th
              colSpan={2}
              className="border-0 transparent-background"
            >
              <FormattedMessage id={title} />
            </th>
          </tr>
        </thead>
        <tbody className="border-bottom">
          {renderDownloadDocuments(isLoading, filteredDocuments, handleDownload)}
        </tbody>
      </Table>
    );
  } else {
    return null;
  }
};


DownloadDocumentsList.defaultProps = {
  documents: [],
  handleDownload: () => {},
};

DownloadDocumentsList.propTypes = {
  documents: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    status: PropTypes.oneOf(['Pending', 'Complete', 'Declined', 'Unknown']).isRequired,
    signatures: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      status: PropTypes.oneOf(['Pending', 'Complete', 'Declined', 'Unknown']),
      signer: PropTypes.shape({
        emailAddress: PropTypes.string,
        name: PropTypes.string,
        role: PropTypes.string,
      }).isRequired,
    })),
  })),
  title: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  handleDownload: PropTypes.func,
};

export default DownloadDocumentsList;



// WEBPACK FOOTER //
// ./src/components/DownloadDocumentList/DownloadDocumentsList.jsx